var _ellipse, _circle, _g, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuShapesBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 108,
    viewBox: "0 0 188 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.5,
    cy: 194.5,
    rx: 151.5,
    ry: 152.5,
    fill: "#2E83EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 26,
    r: 4,
    fill: "#AED3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1894_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.5 104C177.5 128.024 114.524 131 90.5 131C66.4756 131 47 111.524 47 87.5C47 63.4756 66.4756 44 90.5 44C114.524 44 177.5 79.9756 177.5 104Z",
    fill: "#006AEA"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 8,
    r: 8,
    fill: "#2E83EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 95.5C63 102.956 56.9558 109 49.5 109C42.0442 109 20.5 111.456 20.5 104C34.5 105.5 39.0442 86 46.5 86C53.9558 86 63 88.0442 63 95.5Z",
    fill: "#95C3FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1894_1101",
    x: 28,
    y: 29,
    width: 168.5,
    height: 125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1894_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1894_1101",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuShapesBottom);
export default __webpack_public_path__ + "static/media/MobileMenuShapesBottom.6e46f23571e0fe614167d5966824e4a6.svg";
export { ForwardRef as ReactComponent };